import styled from "@emotion/styled"
import Button from "components/Buttons/Button"

const ArticleAsideFinalBtn = styled(Button)`
    position: relative;
`

export default ArticleAsideFinalBtn
